import React, { useCallback } from 'react';
import { IExploreFilters } from 'src/features/common/explore/ducks/explore-nfts/explore-nfts.types';
import { useBlockChains } from 'src/features/common/wallet/hooks/wallet.hooks';
import { FilterCheckboxItem } from './filter-checkbox-item';

interface IProps {
    selected: number[];
    onChange: (key: keyof IExploreFilters, payload: number[]) => void;
}

const FilterBlockchain: React.VFC<IProps> = ({ onChange, selected = [] }) => {
    const blockchains = useBlockChains();

    const onFilterChange = useCallback(
        (id, value: boolean) => {
            const newSet = new Set(selected);
            if (!value) {
                newSet.delete(id);
            } else {
                newSet.add(id);
            }
            onChange('blockchainId', [...newSet]);
        },
        [onChange, selected]
    );

    return (
        <>
            {blockchains.map((blockchain) => (
                <FilterCheckboxItem
                    id={blockchain.id}
                    key={blockchain.id}
                    label={blockchain.name}
                    onChange={onFilterChange}
                    checked={selected.includes(blockchain.id)}
                />
            ))}
        </>
    );
};

export default FilterBlockchain;
